import { PanelContainer } from '../../../common/panel/PanelContainer'
import { BusinessProvince } from './businessProvince'
import { BusinessSize } from './businessSize'
import { BusinessOperatingStatus } from './businessStatus'
import { BusinessYears } from './businessYears'
import { HightLight } from './highlight'
import { IndustryScale } from './industryScale'
import './lang/i18n'
import { Macroeconomics } from './macroeconomics'
import { PopupNoIndustry } from './PopupNoIndustry'
import { RecentNews } from './recentNews'
import { TopIndustryPlayers } from './topIndustryPlayers'

export const Content = () => {
  return (
    <>
      <HightLight />
      <PanelContainer>
        <RecentNews />
        <IndustryScale />
        <Macroeconomics />
        <TopIndustryPlayers />
        <BusinessOperatingStatus />
        <BusinessSize />
        <BusinessYears />
        <BusinessProvince />
      </PanelContainer>
      <PopupNoIndustry />
    </>
  )
}
